var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.417 1.167a5.252 5.252 0 015.25 5.25 5.252 5.252 0 01-5.25 5.25 5.252 5.252 0 01-5.25-5.25 5.252 5.252 0 015.25-5.25zm0 9.333a4.083 4.083 0 100-8.167 4.082 4.082 0 00-4.083 4.084A4.082 4.082 0 006.417 10.5zm4.95.041l1.65 1.65-.826.825-1.65-1.65.826-.825z",
    fill: "#58657C"
  })));
}
export default SvgSearch;